import React from 'react'
import useProduct from 'store/SingleProductProvider'
import { ProductAttributes as StyledProductAttributes } from './MainInfo/MainInfo.style'
import Check2 from '../../Icons/Check2'

export default function ProductAttributes() {
  const {
    product: { attributes },
    chosenVariants,
  } = useProduct()

  if (!Array.isArray(attributes) || !attributes.length) return null

  return (
    <StyledProductAttributes>
      <h4>მახასიათებლები:</h4>
      <ul>
        {Object.keys(chosenVariants).map(attr_id => (
          <li key={attr_id}>
            <Check2 />
            <p>
              {chosenVariants[attr_id].name}: {chosenVariants[attr_id].value}
            </p>
          </li>
        ))}
        {(attributes || []).map(attr => (
          <li key={attr.id}>
            <Check2 />
            <p>
              {attr.name}: {attr.value}
            </p>
          </li>
        ))}
      </ul>

      <a href="#product-details">სრული მახასიათებლები</a>
    </StyledProductAttributes>
  )
}
